<template>
  <div id="app" v-loading="loading">
    <div :id="isMobile ? 'headerMob' : 'header'" v-if="$route.path.toLowerCase() != '/login' || isError"
      :class="$route.path.toLowerCase() == '/usercenter' ? 'no-shadow border-bottom' : ''">
      <div :class="$route.path.toLowerCase() == '/usercenter' ? 'header no-maxwidth' : 'header'">
        <img :class="isMobile ? 'mob' : ''" :src="Logo" @click="$router.replace('/')" />
        <div class="line">&nbsp;</div>
        <div class="text">
          <h1 :class="isMobile ? 'mobText' : ''">FEITEM微观表征数智化平台</h1>
        </div>
        <div :class="isMobile ? 'hide' : 'buttonGroup'">
          <div v-if="!isLogin" @click="$router.replace('/login')">
            <i class="el-icon-user icon"></i>登录
          </div>
          <div v-if="!isLogin" @click="$router.replace({ name: 'login', query: { type: '2' } })">
            <i class="el-icon-s-order icon"></i>注册
          </div>
          <div class="width-100" v-if="isLogin && $route.path.toLowerCase() != '/usercenter'"
            @click="$router.replace('/usercenter')">
            <i class="el-icon-user-solid icon"></i>个人中心
          </div>
          <div class="width-100"
            v-if="(isLogin && $route.path.toLowerCase() == '/usercenter') || $route.path.toLowerCase() == '/modeldetail'"
            @click="$router.replace('/')">
            <i class="el-icon-s-home icon"></i>返回首页
          </div>
          <div class="width-100" v-if="isLogin" @click="logout">
            <i class="el-icon-switch-button icon"></i>退出登录
          </div>
          <div class="width-100" @click="isShowPost = true">
            <i class="el-icon-edit-outline icon"></i>意见反馈
          </div>
        </div>
      </div>
    </div>
    <div id="route" :class="routeClass" :style="isMobile ? 'min-height:calc(100vh - 80px - 88px)' : ''">
      <RouterView v-if="!isError" />
      <Error :msg="errorMsg" v-else />
    </div>

    <div id="homeFooter" v-if="$route.path.toLowerCase() != '/usercenter' && $route.path.toLowerCase() != '/login'"
      :class="isMobile ? 'hide' : ''">
      <div class="footer">
        <div class="left">
          <div>
            <div class="info"><img :src="Mail" />邮箱:sales@feitem.com.cn</div>
            <div class="info"><img :src="Address" />地址:河南自贸试验区开封片区郑开大道八大街以西三合国际4楼</div>
          </div>
          <div class="copyright">
            COPYRIGHT © 2024 河南元宇宙仪器有限公司 ALL RIGHTS RESERVED 豫ICP备2023009490号-1
          </div>
        </div>
        <div class="right">
          <div class="imgBox">
            <img :src="Service" />
            <div>微信客服</div>
          </div>
        </div>
      </div>
    </div>

    <div id="goTop" :class="$root.isMob() ? 'mob' : ''" @click="goTop('right')">
      <i class="el-icon-caret-top"></i>
    </div>

    <el-dialog title="意见反馈" :visible.sync="isShowPost" width="30%" @open="getPostFormInfo()" @close="resetPostForm()">
      <div class="post" v-loading="postLoading">
        <div class="title">{{ postFormText }}</div>
        <div class="form">
          <el-select class="item" v-model="postForm.category_id" filterable placeholder="请选择问题类型">
            <el-option v-for="item in postFromOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-input class="item" placeholder="请输入姓名" v-model="postForm.name" clearable></el-input>
          <el-input class="item" placeholder="请输入邮箱" v-model="postForm.email" clearable></el-input>
          <el-input class="item" placeholder="请输入手机号" v-model="postForm.mobile" clearable></el-input>
          <el-input class="item" placeholder="请输入主题" v-model="postForm.subject" clearable></el-input>
          <el-input class="item" type="textarea" placeholder="请输入反馈内容" v-model="postForm.content"
            :autosize="{ minRows: 4 }" clearable></el-input>
          <div class="buttonBox">
            <el-button type="primary" @click="submitPost">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="dialog copyRight" title="版权声明" :visible.sync="showCopyRight" width="80%">
      <div>
        <div class="copyRightBox" v-html="copyRightText">
        </div>
        <div class="buttonGroup">
          <el-button type="primary" @click="showCopyRight = false">我已知晓</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 移动端菜单S -->
    <mobMenus v-if="$route.path == '/' || $route.path == '/modelDetail'" />
    <!-- 移动端菜单E -->
  </div>
</template>

<script>
import { RouterView } from 'vue-router';
import axios from 'axios';
import Error from '@/components/lib/error.vue';
import Logo from '@/assets/img/logo.png';
import LogoFooter from '@/assets/img/logo_footer.png';
import Service from '@/assets/img/service.png';
import Mail from '@/assets/img/mail.png';
import Address from '@/assets/img/address.png';
import mobMenus from '@/components/lib/mobMenus.vue';

export default {
  name: 'App',
  components: {
    RouterView,
    Error,
    mobMenus,
  },
  data() {
    return {
      Logo: Logo,
      LogoFooter: LogoFooter,
      Service: Service,
      Mail: Mail,
      Address: Address,
      username: "",
      password: "",
      isError: false,
      errorMsg: "",
      isLogin: false,
      routeClass: "",
      isMobile: false,
      isShowPost: false,
      postLoading: false,
      loading: false,
      copyRightText: "加载中...",
      showCopyRight: false,
      postForm: {
        category_id: "",
        name: "",
        email: "",
        mobile: "",
        subject: "",
        content: ""
      },
      postFormKeysName: {
        category_id: "问题类型",
        name: "姓名",
        email: "邮箱",
        mobile: "手机号",
        subject: "主题",
        content: "反馈内容"
      },
      postFromOptions: [],
      postFormText: "",
      keyCode: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    }
  },
  methods: {
    async getCopyRight() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/cms/getArticle?id=2', {
        });

        let data = res.data;
        if (data.code === 1) {
          this.copyRightText = data.data.content;
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false
      }
    },
    async getBanner() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/cms/banerslist', {
          headers: {
            token: this.$root.token
          }
        });

        let data = res.data;
        if (data.code === 1) {
          return data.data;
        } else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false
      }
    },
    async checkLogin() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/user/userinfo', {
          headers: {
            token: this.$root.token
          }
        });

        let data = res.data;
        if (data.code === 1) {
          this.isLogin = true;
          return data.data;
        }
        else {
          this.isLogin = false;
          return false;
        }
      }
      catch (error) {
        this.isLogin = false;
        if (error.response && (error.response.status == 401 || error.response.status == 404)) {
          return false;
        }
        this.netError(error);
        return false;
      }
    },
    async getUserInfo() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/user/userinfo', {
          headers: {
            token: this.$root.token
          }
        });

        let data = res.data;
        if (data.code === 1) {
          return data.data;
        } else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      } catch (error) {
        this.netError(error);
        return false;
      }
    },
    async login(username, password) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + "index.php/api/user/login",
          data: {
            account: username,
            password: password
          },
        });

        let data = res.data;
        if (data.code == 1) {
          //判断是否需要弹出版权声明
          if (data.data.userinfo.loginnum == 1) {
            this.showCopyRight = true;
          }
          this.$root.token = data.data.userinfo.token;
          window.localStorage.setItem("token", data.data.userinfo.token);
          this.$notify({
            type: 'success',
            title: '通知',
            message: data.msg
          });
          //检查是否存在this.$route.query.redirect.djId
          if (this.$route.query.redirect) {
            if (this.$route.query.redirect.djId) {
              window.location.href = "/#/usercenter?djId=" + this.$route.query.redirect.djId;
              return true;
            }
          }
          window.location.href = "/#/usercenter";
          return true;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async reg(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + "index.php/api/user/register",
          data: form,
        });

        let data = res.data;
        if (data.code == 1) {
          this.$notify({
            type: 'success',
            title: '通知',
            message: data.msg
          });
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getlabName() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/settledunit/unitlist',
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getJobList() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/user/career_config',
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async logout() {
      this.loading = true;
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + "index.php/api/user/logout",
          headers: {
            token: this.$root.token
          }
        });

        let data = res.data;
        if (data.code == 1) {
          window.localStorage.removeItem("token");
          this.$notify({
            type: 'success',
            title: '通知',
            message: data.msg
          });
          this.loading = false;
          if (this.$route.path.toLowerCase() != '/') {
            this.$router.replace("/");
          }
          else {
            this.checkLogin();
          }
        }
        else {
          this.loading = false;
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
        }
      }
      catch (error) {
        this.loading = false;
        this.netError(error);
        return false;
      }
    },
    async getDjCate() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/equipment/djcategorys',
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getDjArticle(keyword = '', cate = 0, page = 1) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/equipment/vrdjlist?category_id=' + cate + '&keyword=' + keyword + '&list_rows=&page=' + page,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getLearnCate() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/video/categorylist',
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getLearnDetail(id) {
      try {
        const res = await axios.get(window.config.api + '/index.php/api/video/videoinfo?id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 401) {
          this.netError(data)
          return false;
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getLearnList(keyword = '', cate = 0, page = 1, limit = 4, isRandom = false) {
      try {
        let res = null;
        if (isRandom) {
          res = await axios.get(window.config.api + 'index.php/api/video/randomvideolist?' + '&list_rows=' + limit,
            {
              headers: {
                token: this.$root.token
              }
            }
          )
        }
        else {
          res = await axios.get(window.config.api + 'index.php/api/video/videolist?cat_id=' + cate + '&keyword=' + keyword + '&list_rows=' + limit + '&page=' + page,
            {
              headers: {
                token: this.$root.token
              }
            }
          )
        }

        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getDjData(id) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/equipment/djinfo?id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getDjDoc(id) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/equipment/documentlist?dj_id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getDjVideos(id, type = 1) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/equipment/videolist?dj_id=' + id + '&type=' + type,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async saveUserInfo(data) {
      let info = data;
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + "index.php/api/user/profile",
          data: info,
          headers: {
            token: this.$root.token
          }
        });

        let data = res.data;
        if (data.code == 401) {
          this.netError(data)
          return false;
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getTestsList(page = 1) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/theory/paperlist?page=' + page + '&list_rows=10',
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 401) {
          this.netError(data)
          return false;
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getTestsDetail(id) {
      try {
        const res = await axios.get(window.config.api + '/index.php/api/theory/testslist?paper_id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 401) {
          this.netError(data)
          return false;
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async submitTests(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/theory/submitpaper',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 401) {
          this.netError(data)
          return false;
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getTestsLog(id = 0, page = 1, limit = 5, keyword = "") {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/theory/examlist?paper_id=' + id + '&page=' + page + '&list_rows=' + limit + '&keyword=' + keyword,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },

    //练习记录
    async getUnityTestLog(page = 1, limit = 5) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/stepspractice/practicelist?page=' + page + '&list_rows=' + limit,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },

    //获取练习记录详情
    async getUnityTestLogDetail(id) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/stepspractice/practiceinfo?practice_id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },

    async getPracticeLog(page = 1, limit = 5) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/practice/practicelist?page=' + page + '&list_rows=' + limit,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getTestsPaperAnswer(id) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/theory/examresult?exam_id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getPracticeAnswer(id) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/practice/practiceresult?practice_id=' + id,
          {
            headers: {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getUnityLog(id = 0, page = 1, limit = 5, keyword = "") {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/stepseamine/examlist?dj_id=' + id + "&page=" + page + "&list_rows=" + limit + "&keyword=" + keyword,
          {
            headers:
            {
              token: this.$root.token
            }
          }
        )

        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async changePassword(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/user/changepwd',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 1) {
          this.$notify({
            type: 'success',
            title: '通知',
            message: '修改成功'
          });
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async sendCaptcha(event, form) {
      form.event = event;
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/ems/send',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async resetpwd(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/user/resetpwd',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async changeMail(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/user/changeemail',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getPaperInfo(id = "") {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/theory/paperinfo?id=' + id,
          {
            headers:
            {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getPostCate() {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/feedback/categorys',
          {
            headers:
            {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async submitPostForm(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/feedback/submitfeedback',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 1) {
          return data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    isMob() {
      let isMob = (navigator.userAgent.match(/(phone|pad|pod|Mac|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) ? true : false;
      return isMob;
    },
    netError(error) {
      if (error == 'isMob') {
        this.isError = true;
        this.errorMsg = "暂不支持移动端，请使用电脑访问";
      }
      if (error.response) {
        if (error.response.status === 401) {
          if (this.isLogin) {
            this.isLogin = false;
            this.$notify({
              type: 'warning',
              title: '通知',
              message: '登录失效，请重新登录'
            });
          }

          if (this.$route.path.toLowerCase() != '/') {
            this.$router.replace("/#/login");
          }
        }
        else {
          console.error("Error:", error);
          this.isError = true;
        }
      }
      else {
        console.error("Error:", error);
        this.isError = true;
      }
    },
    checkViewPort(id = null) {
      document.getElementById("goTop").style.bottom = "-60px";
      let target = null;
      if (!id) {
        target = window;
      }
      else {
        target = document.getElementById(id);
      }
      let timer = setInterval(() => {
        if (!target) {
          target = document.getElementById(id);
        }
        else {
          target.addEventListener("scroll", () => {
            let top = target.scrollTop;
            let bottomLength = "50px";
            if (this.$root.isMob()) {
              top = target.scrollY;
              bottomLength = "180px";
            }
            if (top > 500) {
              document.getElementById("goTop").style.bottom = bottomLength;
            } else {
              document.getElementById("goTop").style.bottom = "-60px";
            }
          });
          clearInterval(timer);
        }
      }, 50);
    },
    goTop(id = null) {
      if (!id || this.$root.isMob()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      let target = document.getElementById(id);
      //平滑滚动
      target.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    changeRouteClass() {
      let classStr = "";
      if (this.$route.path.toLowerCase() == '/usercenter') {
        if (this.$root.isMob()) {
          classStr = "full-height mob";
        }
        else {
          classStr = "full-height";
        }
      }
      if (this.$route.path.toLowerCase() == '/login') {
        classStr = "full-height-2 full-width no-padding";
      }
      this.routeClass = classStr;
    },
    formatDate(timestamp) {
      //判断timestamp的位数
      if (timestamp.toString().length == 10) {
        timestamp = timestamp * 1000;
      }
      // 将时间戳格式化为YYYY/MM/DD HH:mm:ss
      const padZero = (num) => (num < 10 ? '0' + num : num);
      const date = new Date(timestamp);

      const year = date.getFullYear();
      const month = padZero(date.getMonth() + 1);
      const day = padZero(date.getDate());
      const hour = padZero(date.getHours());
      const minute = padZero(date.getMinutes());
      const second = padZero(date.getSeconds());

      return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    },
    resetDialog() {
      this.$nextTick(() => {
        document.querySelector('.el-dialog__wrapper').scrollTo(0, 0)
      })
    },
    getKeyCode(index) {
      if (index <= this.keyCode.length) {
        return this.keyCode[index];
      }
      return false;
    },
    async getPostFormInfo() {
      this.postLoading = true;
      let data = await this.getPostCate();
      this.postFromOptions = data;
      let userData = await this.checkLogin();
      if (userData) {
        this.postForm.name = userData.name;
        this.postForm.email = userData.email;
        this.postForm.mobile = userData.mobile;
      }

      this.postLoading = false;
    },
    async submitPost() {
      this.postLoading = true;
      //数据验证
      let keys = Object.keys(this.postForm);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (this.postForm[key] == "" && key != 'mobile') {
          this.$notify({
            type: 'warning',
            title: '通知',
            message: '请填写' + this.postFormKeysName[key]
          });
          this.postLoading = false;
          return;
        }
      }

      let data = await this.submitPostForm(this.postForm);
      if (data) {
        this.$notify({
          type: 'success',
          title: '通知',
          message: data.msg
        });
        this.isShowPost = false;
      }
      this.postLoading = false;
    },
    showPost(text = "") {
      this.resetDialog();
      if (text != "") {
        this.postFormText = text;
      }
      this.isShowPost = true;
    },
    async getUnityExamInfo(id = "") {
      if (id == "") {
        return false;
      }
      try {
        const res = await axios.get(window.config.api + 'index.php/api/stepseamine/examinfo?exam_id=' + id,
          {
            headers:
            {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        // console.log(data);
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getPracticeInfo(id = 0) {
      try {
        const res = await axios.get(window.config.api + 'index.php/api/practice/practiceinfo?bank_cat_id=' + id,
          {
            headers:
            {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async submitPractice(form) {
      try {
        const res = await axios({
          method: "post",
          url: window.config.api + 'index.php/api/practice/submitpaper',
          data: form,
          headers: {
            token: this.$root.token
          }
        });
        let data = res.data;
        if (data.code == 401) {
          this.netError(data)
          return false;
        }
        return data;
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    resetPostForm() {
      this.postForm = {
        category_id: "",
        name: "",
        email: "",
        mobile: "",
        subject: "",
        content: ""
      }
    },
    async getCateList() {
      //获取试题方向列表
      try {
        const res = await axios.get(window.config.api + 'index.php/api/practice/catlist',
          {
            headers:
            {
              token: this.$root.token
            }
          }
        )
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    },
    async getModelList(page = 1, limit = 10) {
      //获取模型展示列表
      try {
        const res = await axios.get(window.config.api + 'index.php/api/model/list?page=' + page + '&list_rows=' + limit)
        let data = res.data;
        if (data.code == 1) {
          return data.data;
        }
        else {
          if (data.code == 401) {
            this.netError(data)
            return false;
          }
          this.$notify({
            type: 'error',
            title: '错误',
            message: data.msg
          });
          return false;
        }
      }
      catch (error) {
        this.netError(error);
        return false;
      }
    }
  },
  created() {
    this.getCopyRight();
    if (this.isMob()) {
      this.isMobile = true;
      //this.netError('isMob');
    }
    //接口S
    if (window.localStorage.getItem("token")) {
      this.$root.token = window.localStorage.getItem("token");
    }
    else {
      if (this.$route.path.toLowerCase() == '/usercenter') {
        this.$notify({
          type: 'warning',
          title: '通知',
          message: '请重新登录!'
        });
        if (this.$route.path.toLowerCase() != '/') {
          this.$router.replace("/");
        }
      }
    }

    this.$root.getBanner = this.getBanner;
    this.$root.getUserInfo = this.getUserInfo;
    this.$root.login = this.login;
    this.$root.reg = this.reg;
    this.$root.getDjCate = this.getDjCate;
    this.$root.getDjArticle = this.getDjArticle;
    this.$root.getLearnList = this.getLearnList;
    this.$root.getDjData = this.getDjData;
    this.$root.getDjDoc = this.getDjDoc;
    this.$root.getDjVideos = this.getDjVideos;
    this.$root.saveUserInfo = this.saveUserInfo;
    this.$root.getTestsList = this.getTestsList;
    this.$root.getTestsDetail = this.getTestsDetail;
    this.$root.submitTests = this.submitTests;
    this.$root.getJobList = this.getJobList;
    this.$root.checkLogin = this.checkLogin;
    this.$root.getTestsLog = this.getTestsLog;
    this.$root.getTestsPaperAnswer = this.getTestsPaperAnswer;
    this.$root.getUnityLog = this.getUnityLog;
    this.$root.changePassword = this.changePassword;
    this.$root.sendCaptcha = this.sendCaptcha;
    this.$root.resetpwd = this.resetpwd;
    this.$root.changeMail = this.changeMail;
    this.$root.getPaperInfo = this.getPaperInfo;
    this.$root.getPostCate = this.getPostCate;
    this.$root.submitPostForm = this.submitPostForm;
    this.$root.getUnityExamInfo = this.getUnityExamInfo;
    this.$root.getPracticeInfo = this.getPracticeInfo;
    this.$root.submitPractice = this.submitPractice;
    this.$root.getUnityTestLog = this.getUnityTestLog;
    this.$root.getUnityTestLogDetail = this.getUnityTestLogDetail;
    this.$root.getPracticeLog = this.getPracticeLog;
    this.$root.getPracticeAnswer = this.getPracticeAnswer;
    this.$root.getCateList = this.getCateList;
    this.$root.getCopyRight = this.getCopyRight;
    this.$root.logout = this.logout;
    this.$root.getLearnCate = this.getLearnCate;
    this.$root.getLearnDetail = this.getLearnDetail;
    this.$root.getModelList = this.getModelList;
    this.$root.getlabName = this.getlabName;
    //接口E

    //功能S
    this.$root.formatDate = this.formatDate;
    this.$root.resetDialog = this.resetDialog;
    this.$root.isMob = this.isMob;
    this.$root.getKeyCode = this.getKeyCode;
    this.$root.checkViewPort = this.checkViewPort;
    this.$root.goTop = this.goTop;
    this.$root.showPost = this.showPost;
    this.$root.netError = this.netError;
    //功能E

    this.checkLogin();
    this.changeRouteClass();
  },
  beforeUpdate() {
    this.checkLogin();
    this.changeRouteClass();
    this.checkViewPort();
    if (this.$route.path != "/unityEndPage") {
      this.postFormText = "";
    }
  },
}
</script>

<style lang="scss" src="@/assets/css/app.scss"></style>
